import React, { useEffect, useMemo } from "react";
import { useDetectVesselConnection } from "../../../hooks/useDetectVesselConnection";
import Grid from "@mui/material/Grid2";
import { useDurationHandle } from "../calendarDuration/useDurationHandle";
import { DURATION } from "../calendarDuration/durationOption";
import { EngineTrendBase } from "../engine/engineTrendBase.jsx";
import PropTypes from "prop-types";
import { useCustomData } from "./channelData";
import { DEFAULT_LINE_COLORS } from "../../../constants/trendGraph/linesDefaultColors";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";

export const DisplayCustomGraph = (props) => {
  const {
    vesselId,
    currentVessel,
    selectedChart,
    graphData,
    customCharts,
    channels,
    isCustomChartsCreated,
    setGraphData,
    setDataFetchStatus,
  } = props;
  const { connections } = useDetectVesselConnection();
  const isDisconnected = connections.includes(vesselId);

  const chartLines = useMemo(() => {
    if (!customCharts?.length || !channels?.length) return;

    const lines = customCharts.find((ch) => ch.id === selectedChart)?.lines;
    return lines
      ?.filter((line) => channels.some((ch) => ch.chNo === line.chNo))
      ?.map((line, idx) => {
        const channel = channels.find((ch) => ch.chNo === line.chNo);
        const status = channel.status?.split(',');
        const selectedStatusIndex = status?.indexOf(line?.digitalVar);
        const unSelectedStatusIndex = selectedStatusIndex ? 0 : 1;
        return {
          key: `"${line.chNo}"`,
          keyName: `"${line.chNo}"`,
          name: channel.chName,
          color: line.color ?? DEFAULT_LINE_COLORS[idx],
          enableVisibilityIcon: "hidden",
          enable: true,
          channelType: channel.chType,
          digitalVar: line?.digitalVar,
          selectedStatus: status ? status[selectedStatusIndex] : '--',
          unSelectedStatus: status ? status[unSelectedStatusIndex] : '--',
          graphData: []
        };
      });
  }, [customCharts, channels, selectedChart]);

  const { customValues, isLoading, isNoData } = useCustomData({
    vesselId,
    chartId: selectedChart,
    isCustomChartsCreated,
  });

  useDurationHandle(DURATION.SEP, null);
  useEffect(() => {
    setDataFetchStatus({
      isLoading,
      isNoData,
    });
  }, [isLoading, isNoData]);
  return (
    <Grid container spacing={2}>
      <Grid item size={{xs: 12}}>
        <EngineTrendBase
          values={customValues}
          isDurationDisabled={isLoading}
          isNoData={isNoData}
          isDisconnected={isDisconnected}
          vesselId={vesselId}
          vessel={currentVessel}
          isLoading={isLoading}
          selectedChart={selectedChart}
          graphType={GRAPH_TYPE.CUSTOM}
          graphData={graphData}
          setGraphData={setGraphData}
          customChartLines={chartLines}
          isCustomCharts={true}
        />
      </Grid>
    </Grid>
  );
};

DisplayCustomGraph.propTypes = {
  vesselId: PropTypes.string,
  selectedChart: PropTypes.string,
  currentVessel: PropTypes.object,
  graphData: PropTypes.array,
  customCharts: PropTypes.array,
  channels: PropTypes.array,
  isCustomChartsCreated: PropTypes.bool,
  setGraphData: PropTypes.func,
  setDataFetchStatus: PropTypes.func,
};